module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product pmt",
    class: {
      contrasted: _vm.isPageContrasted, fontBigger: _vm.isFontBigger
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.lang === 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Polskie Mosty Technologiczne USA")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Polish Technology Bridge to USA")]) : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element bps clearfix"
  }, [_c('div', {
    staticClass: "text-box"
  }, [(_vm.lang === 'pl') ? _c('ul', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('ul', [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n           Projekt Polskie Mosty Technologiczne ma na celu wspieranie polskich firm w procesie internacjonalizacji. Projekt organizowany jest przez Polską Agencję Inwestycji i Handlu.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\nCelem projektu jest ekspansja na rynek amerykański. Trzeba pamiętać, że USA jest wiodącym krajem, jeśli chodzi o energetykę wiatrową. W ramach etapu krajowego tego projektu wypracowaliśmy strategię ekspansji, którą będziemy konsekwentnie wdrażać w etapie zagranicznym, trwającym do sierpnia 2021. Celem projektu Bioseco jest wybór najatrakcyjniejszego lokalnego rynku na terenie Stanów Zjednoczonych i rozpoznanie wymogów regulacyjnych pozwalających na sprzedaż Bird Protection System. W konsekwencji naszym nadrzędnym celem jest nawiązanie współpracy handlowej z podmiotami w USA.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\nProjekt Polskie Mosty Technologiczne współfinansowany jest z Europejskiego Funduszu Rozwoju Regionalnego w ramach III Osi priorytetowej - Wsparcie innowacji w przedsiębiorstwach; Działanie: 3.3. Wsparcie promocji oraz internacjonalizacji innowacyjnych przedsiębiorstw, Programu Operacyjnego Inteligentny Rozwój 2014-2020. Nr umowy: POIR-03.03.01-00-0001/17-00.\n                "), _c('br'), _c('br'), _vm._v("\n                  Dofinansowanie projektu przez PAIH:"), _c('br'), _vm._v("200.000,00 PLN\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n             Project PMT („Polskie Mosty Technologiczne”) aims to support Polish companies in the process of internationalization. The project is organized by the Polish Investment and Trade Agency.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                  The aim of the project is expansion to the American market. The USA is the leading country in wind energy. As part of the first stage, we have developed an expansion strategy, which we will consistently implement in the second stage, lasting until August 2021. During the project Bioseco aims to select the most attractive market in the United States and to identify regulatory requirements allowing the sale of the Bird Protection System. Consequently, our main goal is to establish commercial cooperation with entities in the USA.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\nThe project PMT (Polskie Mosty Technologiczne) is co-financed from the European Regional Development Fund, under the Priority 3 - Support for innovation in enterprises; Measure: 3.3. Support for the promotion and internationalization of innovative enterprises, the Intelligent Development Operational Program 2014-2020. Agreement number: POIR-03.03.01-00-0001/17-00.\n               "), _c('br'), _c('br'), _vm._v("\n                  Amount of founding from UE:"), _c('br'), _vm._v("\n200.000.00 PLN\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-679ea235"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PMT.vue
// module id = 299
// module chunks = 0